<template>

  <div class="rankingPreview">

    <div v-for="t in tableExcerpt" v-bind:key="t.id" :class="rankingPreviewClass(t)">
      <div class="rankingPreview__item__position">
        {{ t.position }}
      </div>
      <div class="rankingPreview__item__logo">
        <img :src="teamLogo(t)" :alt="'Logo ' + t.teamName">
      </div>
      <div class="rankingPreview__item__name">
        {{ t.teamName }}
      </div>
      <div class="rankingPreview__item__points">
        {{ t.points }}
      </div>
    </div>

  </div>

</template>

<script>
import {teamLogoUrl} from '@/hbf-helper';

export default {
    name: 'RankingPreviewTeam',
    mounted() {
          this.init();
     },
     data() {
          return {
               table: null,
               teamRanking: null,
               /** 1-based index in the sorted table (stable when many rows share position "1") */
               tableSlot: 0,
               tableExcerpt: null,
          }
     },
     methods: {
        init() {
            this.$store.dispatch("fetchData",  {filename: "tables/table_" + this.seasonId + ".json"}).then( (res) => {
                this.table = res.table;
                this.teamRanking = this.table.find(t => t.fmpTeamId == this.teamId);
                if (this.teamRanking) {
                    // Prefer table order over official position: before matchday 1 (and with ties)
                    // every row may report position 1, which breaks excerpt + fade distance.
                    this.tableSlot = this.table.findIndex(t => t.fmpTeamId == this.teamId) + 1;
                    let startPosition = Math.min(this.table.length - 4, Math.max(1, this.tableSlot - 2)) - 1;
                    let endPosition = Math.max(5, Math.min(this.table.length, this.tableSlot + 2));
                    this.tableExcerpt = this.table.slice(startPosition, endPosition);
                }
            });
        },
        tableSlotOf(team) {
            if (!this.table || !team) { return -1; }
            return this.table.findIndex(t => t.fmpTeamId == team.fmpTeamId) + 1;
        },
        rankingPreviewClass(te) {
            var cl = ["rankingPreview__item"];
            let variants = ["rankingPreview__item--lighter48", "rankingPreview__item--lighter40",
                "rankingPreview__item--lighter32", "rankingPreview__item--lighter24"];

            if (this.teamId == te.fmpTeamId) {
                cl.push("rankingPreview__item--highlight");
                return cl.join(" ");
            }

            // Same official rank (ties / all "1" pre-season): uniform fade around the focus team
            if (this.teamRanking && te.position == this.teamRanking.position) {
                cl.push(variants[0]);
                return cl.join(" ");
            }

            const distance = Math.abs(this.tableSlotOf(te) - this.tableSlot);
            let variantIndex = null;
            if (this.tableSlot == 1 || this.tableSlot == this.table.length) {
                variantIndex = distance - 1;
            }
            else if (this.tableSlot == 2 || this.tableSlot == this.table.length - 1) {
                variantIndex = distance;
            }
            else if (distance == 1) {
                variantIndex = 0;
            }
            else if (distance == 2) {
                variantIndex = 2;
            }

            if (variantIndex != null && variants[variantIndex]) {
                cl.push(variants[variantIndex]);
            }

            return cl.join(" ");
        },
        teamLogo(team) {
            return teamLogoUrl(team, 40, this.baseUrl, this.seasonId);
        }
    },
    props: {
        competitionId: {
            type: Number,
            default() { return -1; } 
        },
        seasonId: {
            type: Number,
            default() { return -1; } 
        },
        teamId: {
            type: Number,
            default() { return -1; }      
        }
    },
    computed: {
        baseUrl() {
            return this.$store.getters.getBaseUrl;
        }
    }
}
</script>

<style lang="scss" scoped>

    .rankingPreview {
        @media (min-width: $breakpoint-sm) {
            padding: 0 16px;
        }
    }

    .rankingPreview__item {

        @media (min-width: $breakpoint-sm) {

            &:nth-child(1), &:nth-child(2) {
                margin-bottom: -4px;
            }

            &--highlight {
                &:before {
                    height: 28px;
                    top: 2px;
                }
            }

            &:nth-child(4), &:nth-child(5) {
                margin-top: -4px;
            }

        }

        &--lighter48 {
            opacity: .48;
        }

        &--lighter40 {
            opacity: .4;
        }

        &--lighter32 {
            opacity: .32;
        }

        &--lighter24 {
            opacity: .24;
        }
    }
</style>
